export const isOrderCustomer = (customer) => {
    return customer.customer_id !== undefined;
};
export const isCreditTender = (tender) => {
    return tender.tender_type === 'CREDIT';
};
export const isGiftCardTender = (tender) => {
    return tender.tender_type === 'GIFT_CARD';
};
export const isHouseAccountTender = (tender) => {
    return tender.tender_type === 'HOUSE_ACCOUNT';
};
